/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplyingProgram
 */
export interface ApplyingProgram {
    /**
     * プログラムID
     * @type {number}
     * @memberof ApplyingProgram
     */
    id: number;
    /**
     * プログラム名
     * @type {string}
     * @memberof ApplyingProgram
     */
    name: string;
    /**
     * 適用内容
     * @type {string}
     * @memberof ApplyingProgram
     */
    description: string;
    /**
     * 無料回数の初期値(nullのときは無制限)
     * @type {number}
     * @memberof ApplyingProgram
     */
    defaultFreeCount: number | null;
    /**
     * 残りの無料回数(nullのときは無制限)
     * @type {number}
     * @memberof ApplyingProgram
     */
    remainingFreeCount: number | null;
    /**
     * 内容が月にx件無料のプログラムか
     * @type {boolean}
     * @memberof ApplyingProgram
     */
    isMonthly: boolean;
    /**
     * 開始日(Y/m/d)
     * @type {string}
     * @memberof ApplyingProgram
     */
    startDate: string;
    /**
     * 終了日(Y/m/d) nullのときは無期限
     * @type {string}
     * @memberof ApplyingProgram
     */
    endDate: string | null;
}

export function ApplyingProgramFromJSON(json: any): ApplyingProgram {
    return ApplyingProgramFromJSONTyped(json, false);
}

export function ApplyingProgramFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplyingProgram {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'defaultFreeCount': json['default_free_count'],
        'remainingFreeCount': json['remaining_free_count'],
        'isMonthly': json['is_monthly'],
        'startDate': json['start_date'],
        'endDate': json['end_date'],
    };
}

export function ApplyingProgramToJSON(value?: ApplyingProgram | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'default_free_count': value.defaultFreeCount,
        'remaining_free_count': value.remainingFreeCount,
        'is_monthly': value.isMonthly,
        'start_date': value.startDate,
        'end_date': value.endDate,
    };
}

